<template>
  <div class="record-comment-skeleton">
    <div class="single-record-comment">
      <div class="avatar-container x-product-skeleton"></div>
      <div class="comment-container">
        <div class="header-container">
          <div class="title-text x-product-skeleton"></div>
        </div>
        <div class="content-container">
          <div class="text-content width-50 x-product-skeleton"></div>
          <div class="text-content width-30 x-product-skeleton"></div>
        </div>
      </div>
    </div>
    <div class="single-record-comment single-record-comment-reserve">
      <div class="avatar-container x-product-skeleton"></div>
      <div class="comment-container">
        <div class="header-container">
          <div class="title-text x-product-skeleton"></div>
        </div>
        <div class="content-container">
          <div class="text-content width-70 x-product-skeleton"></div>
          <div class="text-content width-40 x-product-skeleton"></div
          ><div class="text-content width-30 x-product-skeleton"></div>
          <div class="text-content width-60 x-product-skeleton"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>
<style lang="scss" scoped>
.record-comment-skeleton {
  .single-record-comment {
    width: 100%;
    height: auto;
    padding: 23px 32px;
    box-sizing: border-box;
    display: flex;
    position: relative;
    .avatar-container {
      width: 36px;
      height: 36px;
      flex: 0 0 36px;
      border-radius: 50%;
    }
    .comment-container {
      margin: 0 12px;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .header-container {
        display: flex;
        justify-content: space-between;
        width: 100%;
        .title-text {
          width: 40%;
          height: 12px;
        }
      }
      .content-container {
        width: 100%;
        .text-content {
          margin-top: 12px;
          height: 12px;
          width: 60%;
        }
        .width-30 {
          width: 30%;
        }
        .width-40 {
          width: 40%;
        }
        .width-50 {
          width: 50%;
        }
        .width-60 {
          width: 60%;
        }
        .width-70 {
          width: 70%;
        }
      }
    }
  }
  .single-record-comment-reserve {
    flex-direction: row-reverse;
    .header-container {
      flex-direction: row-reverse;
    }
  }
}
</style>
